import { tailwind } from "@theme-ui/presets"

export default {
  ...tailwind,
  initialColorMode: `dark`,
  useCustomProperties: true,
  colors: {
    ...tailwind.colors,
    secondary: tailwind.colors.indigo[6],
    text: "#B3B3F1",
    primary: tailwind.colors.pink[4],
    background: tailwind.colors.gray[8],
    textMuted: tailwind.colors.gray[5],
    modes: {
      light: {
        text: tailwind.colors.gray[8],
        primary: tailwind.colors.pink[7],
        background: "#B3B3F1",
        textMuted: tailwind.colors.gray[8],
      },
      dark: {
        text: "#B3B3F1",
        primary: tailwind.colors.pink[4],
        background: tailwind.colors.gray[8],
        textMuted: tailwind.colors.gray[5],
      },
    },
  },
  styles: {
    ...tailwind.styles,
    root: {
      ...tailwind.styles.root,
      fontFamily: 'Montserrat, Segoe UI, Lato, sans-serif',
      color: `text`,
      backgroundColor: `background`,
    },
    Footer: {
      textAlign: `center`,
      display: `block`,
      color: `textMuted`,
      px: [2, 3],
      py: [3, 4],
    },
    Header: {
      px: [3, 4],
      py: [2, 3],
      fontSize: 2,
      display: `flex`,
      alignItems: `center`,
      flexWrap: `wrap`,
    },
    Main: {
      ...tailwind.styles.Main,
      position: `relative`,
    },
    Container: {
      maxWidth: `5xl`,
    },
    p: {
      fontSize: [1, 2],
      letterSpacing: `-0.003em`,
      lineHeight: `body`,
      "--baseline-multiplier": 0.179,
      "--x-height-multiplier": 0.35,
    },
    h1: {
      ...tailwind.styles.h1,
      fontSize: [5, 6],
      mt: 2,
    },
    h2: {
      ...tailwind.styles.h2,
      fontSize: [4, 5],
      mt: 2,
    },
    h3: {
      ...tailwind.styles.h3,
      fontSize: [3, 4],
      mt: 3,
    },
    h4: {
      ...tailwind.styles.h4,
      fontSize: [2, 3],
    },
    h5: {
      ...tailwind.styles.h5,
      fontSize: [1, 2],
    },
    h6: {
      ...tailwind.styles.h6,
      fontSize: 1,
      mb: 2,
    },
  },
  buttons: {
    toggle: {
      fontFamily: 'Montserrat, Segoe UI, Lato, sans-serif',
      color: `background`,
      border: `none`,
      backgroundColor: `text`,
      cursor: `pointer`,
      alignSelf: `center`,
      px: 3,
      py: 2,
      ml: 3,
    },
  },
}
